
// SCRIPTS

import { SecureHomePage } from './home/home.page'; export { SecureHomePage };
import { UserDirectoryPage } from './communications/user-directory/user-directory.page'; export { UserDirectoryPage };
import { TaskTrackerPage } from './task-tracking/scripts/task-tracker.page'; export { TaskTrackerPage };
import { ContractsPage } from './reporting/contracts/scripts/contracts.page'; export { ContractsPage };
import { SiteActivationPage } from './reporting/sites/site-activation/scripts/site-activation.page'; export { SiteActivationPage };
import { ForecastsPage } from './reporting/forecasts/scripts/forecasts.page'; export { ForecastsPage };
import { ExecutiveSummaryPage } from './reporting/executive-summary/scripts/executive-summary.page'; export { ExecutiveSummaryPage };
import { AnnouncementsPage } from './communications/announcements/scripts/announcements.page'; export { AnnouncementsPage };
import { PrescreeningPage } from './reporting/prescreening/scripts/prescreening.page'; export { PrescreeningPage };
import { EnrollmentPage } from './reporting/enrollment/scripts/enrollment.page'; export { EnrollmentPage };
import { DataCompletenessPage } from './reporting/data-completeness/scripts/data-completeness.page'; export { DataCompletenessPage };
import { FinancialsPage } from './reporting/financials/scripts/financials.page'; export { FinancialsPage };
import { SitesTrackerPage } from './reporting/sites-tracking/scripts/sites-tracker.page'; export { SitesTrackerPage };
import { WearablesPage } from './reporting/wearables/scripts/wearables.page'; export { WearablesPage };
import { InventorySummaryPage } from './biospecimens/inventory-summary/scripts/inventory-summary.page'; export { InventorySummaryPage };
import { InventorySummaryPublicPage } from '../general/inventory-summary/inventorysummary-publicview.page'; export { InventorySummaryPublicPage };
import { InventorySearchPage } from './biospecimens/inventory-search/scripts/sample-search.page'; export { InventorySearchPage };
import { MyRequestsPage } from './biospecimens/sample-request-form/request-dashboard/scripts/request-dashboard.page'; export { MyRequestsPage }
import { RequestFormPage } from './biospecimens/sample-request-form/request-form/scripts/request-form.page'; export { RequestFormPage }
import { RequestReviewPage } from './biospecimens/sample-request-form/request-review-dashboard/scripts/request-review-dashboard.page'; export { RequestReviewPage }
import { SiteHealthPage } from '../secure/reporting/site-health/scripts/site-health.page'; export { SiteHealthPage };
import { MetricToolPage } from '../secure/reporting/site-health/metric-tool/scripts/metric-tool.page'; export { MetricToolPage };

// STYLES
import './home/home.scss';
import './communications/user-directory/user-directory.scss';
import './task-tracking/task-tracker.scss';
import './reporting/forecasts/forecasts.scss';
import './reporting/contracts/contracts.scss';
import './reporting/sites/site-activation/site-activation.scss';
import './communications/site-faqs/site-faqs.scss';
import './reporting/forecasts/forecasts.scss';
import './reporting/executive-summary/executive-summary.scss';
import './communications/announcements/announcements.scss';
import './reporting/prescreening/prescreening.scss';
import './reporting/sites/site-activation/components/milestone-dashboard-tab/milestone-dashboard-tab.scss';
import './reporting/enrollment/enrollment.scss';
import './reporting/data-completeness/data-completeness.scss';
import './reporting/financials/financials.scss';
import './reporting/sites-tracking/sites-tracker.scss';
import './reporting/wearables/wearables.scss';
import './biospecimens/inventory-summary/inventory-summary.scss';
//import "jQuery-QueryBuilder/dist/css/query-builder.default.css";
import './biospecimens/inventory-search/inventory-search.scss';
import "bootstrap-slider";
import "bootstrap-slider/dist/css/bootstrap-slider.min.css";

import './biospecimens/sample-request-form/request-dashboard/request-dashboard.scss';
import './biospecimens/sample-request-form/request-form/request-form.scss';
import './reporting/site-health/site-health.scss';
import './reporting/site-health/metric-tool/metric-tool.scss';
